export default {
  uploading: 'Uploading',
  cancel: 'Cancel',
  editTitle: 'Edit Reference Model',
  newTitle: 'New Reference Model',
  save: 'Save',
  create: 'Create',
  modelCodename: 'Model Codename',
  json: 'JSON',
  downloadPkl: 'Download current PKL file',
  choosePklFile: 'Choose PKL file',
  pklRequired: 'PKL file is required',
  codenameRequired: 'Codename is required',
  codenameInvalid: 'Codename can only contain alphanumeric characters, "-", or "_"',
  codenameExists: 'Codename already exists',
  jsonRequired: 'JSON is required',
  invalidJson: 'Invalid JSON'
}
